module.exports = "/images/cmrad-hero-img.jpg?4bff32268ae5affac1257ab8f377bfa9";